import React, { useState } from 'react';
import { IbanOwnerType } from '../Types';
import { FloatLabel } from '../../../Components';

interface Props<T> {
    dictIbanOwnerAsker: string;
    dictIbanOwnerRepresentant: string;
    dictRepresentantNameLabel: string;
    dictErrorSubmit: string;
    initialOwner?: IbanOwnerType;
    initialRepresentantName?: string;
    onChange?: (owner: IbanOwnerType, name?: string) => void;
    isFormInvalid?: boolean;
    values: T;
    errors: Partial<Record<keyof T, string>>;
}

export const IbanOwnerSelector: React.FC<Props<any>> = ({
    dictIbanOwnerAsker,
    dictIbanOwnerRepresentant,
    dictRepresentantNameLabel,
    dictErrorSubmit,
    initialOwner = IbanOwnerType.OwnerAsker,
    initialRepresentantName = '',
    onChange,
    errors,
}) => {
    const [ibanOwner, setIbanOwner] = useState<IbanOwnerType>(initialOwner);
    const [legalRepresentantName, setLegalRepresentantName] = useState<string>(
        initialRepresentantName
    );

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setLegalRepresentantName(value);
        onChange?.(ibanOwner, value);
    };

    return (
        <div className="d-flex flex-column">
            {/* Owner Asker */}
            <div>
                <input
                    type="radio"
                    id="ownerAsker"
                    name="ibanOwner"
                    checked={ibanOwner === IbanOwnerType.OwnerAsker}
                    onChange={() => {
                        setIbanOwner(IbanOwnerType.OwnerAsker);
                        setLegalRepresentantName('');
                        onChange?.(IbanOwnerType.OwnerAsker);
                    }}
                />
                <label htmlFor="ownerAsker">{dictIbanOwnerAsker}</label>
            </div>

            {/* Owner Legal Representant */}
            <div>
                <input
                    type="radio"
                    id="ownerLegalRepresentant"
                    name="ibanOwner"
                    checked={ibanOwner === IbanOwnerType.OwnerLegalRepresentant}
                    onChange={() => {
                        setIbanOwner(IbanOwnerType.OwnerLegalRepresentant);
                        onChange?.(
                            IbanOwnerType.OwnerLegalRepresentant,
                            legalRepresentantName
                        );
                    }}
                />
                <label htmlFor="ownerLegalRepresentant">
                    {dictIbanOwnerRepresentant}
                </label>
            </div>

            {/* Legal Representant Name Input */}
            {ibanOwner === IbanOwnerType.OwnerLegalRepresentant && (
                <div className="row mt-2">
                    <div className="col-10">
                        <FloatLabel
                            active={!!legalRepresentantName}
                            label={dictRepresentantNameLabel}
                            labelId="legalRepresentantName"
                        >
                            <input
                                type="text"
                                name="legalRepresentantName"
                                value={legalRepresentantName}
                                onChange={handleNameChange}
                            />
                        </FloatLabel>

                        {errors.legalRepresentantName && (
                            <div className="row">
                                <label className="alert-danger m-auto">
                                    {dictErrorSubmit}
                                </label>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
